// extracted by mini-css-extract-plugin
export default {"slider__content":"slider_slider__content__r7EyT"};